// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"87":"jobs","353":"contact","594":"about","927":"synthesis","946":"news","962":"home","983":"products"}[chunkId] || chunkId) + "." + {"87":"c762da68","353":"bff3807c","594":"d99e5c68","721":"06417d28","927":"af8bb9e4","946":"ec2f3747","962":"d4ed7833","983":"b7e27c3f"}[chunkId] + ".js";
};